<template>
  <header id="header" :class="{ headerFix: scrolled }">
    <div>
      <Navbar ref="navbar" />
      <div class="container">
        <div class="header-top">
          <div class="logo">
            <router-link :to="$i18nRoute({ name: 'home' })">
              <img src="@/assets/logo.webp" alt="logo" />
            </router-link>
          </div>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn dark v-on="on" class="navbar-toggler">
                <img src="@/assets/navbar-toggler-icon.png" alt="" />
              </v-btn>
            </template>
            <v-list class="navbar-collapse">
              <v-list-item>
                <router-link :to="$i18nRoute({ name: 'profile' })">{{
                  $t('Личный кабинет')
                }}</router-link>
              </v-list-item>
              <v-list-item>
                <Language />
              </v-list-item>
              <v-list-item>
                <Widget position="MainMenu" />
              </v-list-item>
              <v-list-item>
                <div class="visImpaired">
                  <a href="#" @click.prevent="addSpecialMenu">{{ $t('Версия для слабовидящих') }}</a>
                </div>
              </v-list-item>
            </v-list>
          </v-menu>
          <div class="logo-txt">
            <h1 class="text-md">
              {{
                $t(
                  'Единый портал общественного обсуждения проектов нормативных правовых актов Кыргызской Республики'
                )
              }}
            </h1>
          </div>
        </div>
        <div class="header-left">
          <div class="logo">
            <router-link :to="$i18nRoute({ name: 'home' })">
              <img src="@/assets/logo.webp" alt="logo" />
            </router-link>
          </div>
          <Search />
        </div>
        <div class="header-right">
          <ProfileDropdown />
          <Language />
        </div>
      </div>
      <div class="mob-search">
        <Search />
      </div>
      <Navigation />
    </div>
  </header>
</template>

<script>
import Widget from '@/components/app/Widget'
import Navbar from '@/components/header/Navbar'
import Navigation from '@/components/Navigation'
import Search from '@/components/Search'
import Language from '@/components/header/Language'
import ProfileDropdown from '@/components/header/ProfileDropdown'
import { Trans } from "@/plugins/Translation"

export default {
  components: {
    Widget,
    Navbar,
    Navigation,
    Search,
    Language,
    ProfileDropdown
  },
  data() {
    return {
      scrolled: false,
    }
  },
  methods: {
    async logout() {
      await this.$store.dispatch('logout')
      await this.$router.push(Trans.i18nRoute({ name: 'login' }))
    },
    handleScroll() {
      this.scrolled = window.scrollY > 200
    },
    //вызываем метод "addSpecialMenu" у дочернего класса Navbar
    addSpecialMenu() {
      this.$refs.navbar.addSpecialMenu()
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
